import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import mapProps from 'recompose/mapProps';
import lifecycle from 'recompose/lifecycle';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import {
  getActiveCanvasDrawer,
  updateActiveCanvasDrawer,
  setCompletedDrawerWithTimer,
} from '../CanvasDrawers/duck';
import withProductCustomisation from '../../hocs/withProductCustomisation';
import withQueryParams from '../../hocs/withQueryParams';
import withProduct from '../../hocs/withProduct';
import CreationForm from './CreationForm';
import { withModel } from '../../data-providers/model';
import { fetchPrismicProduct } from 'src/client/js/store/thunks/prismic/product';
import { getPrismicProductDrawer, getPrismicProduct, getPrismicProductByLocale } from 'src/client/js/store/selectors/prismic/product';
import { setBookPreviewActivePage } from '../BookPreview/duck';
import { getGiftwrapComponents, replaceAddons } from '../CanvasDrawers/helpers';
import { findProductVariant } from 'src/common/utils/product';
import { skus } from 'src/common/config/product';
import { trackDrawerOpenTab, trackDrawerCloseTab, trackDrawerSaveTab } from '../../../analytics/category/product';

// Moving to a more global function to call basic drawer tracking
// TODO: Slowly remove this logic
const handledDrawerTracking = [
  'adventurer', 'book_formats', 'inscription', 'address', 'interest', 'companion',
  'birthday', 'bears', 'family_members', 'qualities', 'multi_adventurer',
];

const enhance = compose(
  withProduct,
  withProductCustomisation,
  withQueryParams,
  connect(
    (state, props) => ({
      prismicProductLangs: getPrismicProduct(
        state,
        props.productId
      ),
      activeDrawer: getActiveCanvasDrawer(state),
      prismicProduct: getPrismicProductByLocale(
        state,
        props.productId,
        props.productCustomisation.locale
      ),
      localisedDrawer: getPrismicProductDrawer(
        state,
        props.productId,
        props.productCustomisation.locale,
        props.drawer.sliceType,
      ),
    }),
    dispatch => ({
      handleActiveDrawer: (activeDrawer) => dispatch(updateActiveCanvasDrawer(activeDrawer)),
      setBookPreviewActivePage: page =>
        dispatch(setBookPreviewActivePage(page)),
      setCompletedDrawer: drawerId => {
        if (!handledDrawerTracking.includes(drawerId)) {
          trackDrawerSaveTab(drawerId);
        }
        setCompletedDrawerWithTimer(dispatch)(drawerId, 4000);
      }
    }),
  ),
  connect(
    null,
    (dispatch, props) => ({
      fetchPrismicProduct: (sku, locale) =>
        dispatch(fetchPrismicProduct(sku, locale, props)),
    })
  ),
  withHandlers({
    handleFormikSubmit: props => (values, nextDrawer) => {
      values = omit(values, ['base']);

      let drawer = props.drawer.sliceType;
      drawer = drawer === 'interest' ? `${drawer}::${props.drawer.primary.type}` : drawer;

      const newProps = {
        ...props,
        queryParams: { ...props.queryParams, ...values },
        productCustomisation: { ...props.productCustomisation, ...values },
      };

      /* Check compatibility of giftwrap and swap sizes if necessary */
      const availableGiftwrapComponents = getGiftwrapComponents(newProps);
      const components = replaceAddons(newProps, availableGiftwrapComponents);
      values = { ...values, components };

      /* Check and remove format/cover/box if necessary */
      const newVariant = findProductVariant(
        newProps.product.variants,
        omit(newProps.productCustomisation, ['box', 'cover', 'components'])
      );
      if (newVariant.options) {
        values = { ...values, ...pick(newVariant.options, ['box', 'cover', 'size']) };
      } else {
        const toOmit = ['box', 'cover', 'format_identifier'];
        values = omit(values, toOmit);
        props.removeQueryParams(toOmit);
        props.removeProductCustomisation(toOmit);
      }

      /* Check compatibility of TJH address and partially clear if necessary */
      if (props.productId === skus.TJH && values.locale) {
        const hasLocaleChanged = values.locale !== props.productCustomisation.locale;
        if (hasLocaleChanged) {
          const toOmit = ['lat', 'lng'];
          values = omit(values, toOmit);
          props.removeQueryParams(toOmit);
          props.removeProductCustomisation(toOmit);
        }
      }

      props.updateProductCustomisation(values);
      props.updateQueryParams(values);
      props.setCompletedDrawer(drawer);

      if (props.drawer.primary.ctaPageNumber) {
        props.setBookPreviewActivePage(props.drawer.primary.ctaPageNumber);
      }

      if (props.activeDrawer !== nextDrawer) {
        props.handleActiveDrawer(nextDrawer);
      }
    },
  }),
  withModel,
  mapProps(props => ({
    completedDrawersMap: props.completedDrawersMap,
    productCustomisation: props.productCustomisation,
    queryParams: props.queryParams,
    onFormikSubmit: props.handleFormikSubmit,
    productKey: props.productKey,
    form: props.form,
    product: props.product,
    fetchPrismicProduct: props.fetchPrismicProduct,
    model: props.model,
    localisedDrawer: props.localisedDrawer,
    prismicProduct: props.prismicProduct,
    drawer: {
      sliceType: props.drawer.sliceType,
      ...props.drawer.primary,
      items: props.drawer.items,
    },
  })),
  lifecycle({
    componentDidMount() {
      const props = this.props;
      const drawerType = props.drawer.sliceType;
      if (!handledDrawerTracking.includes(drawerType)) {
        trackDrawerOpenTab(drawerType);
      }
    },
    componentWillUnmount() {
      const props = this.props;
      const drawerType = props.drawer.sliceType;
      if (!handledDrawerTracking.includes(drawerType)) {
        trackDrawerCloseTab(drawerType);
      }
    }
  })
);

export default enhance(CreationForm);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/index.js